export const RollcallMonthlySummaryreport = [
  {
    "s_no": 1,
    "EmployeeId": 1,
    "UserName": "Baji",
    "WorkingDays": 25,
    "Present": 19,
    "Late": 2,
    "Absent": 0,
    "Leave": "",
    "Holidays": 0,
    "WeekOff": 4,
    "OTHrs": "18:54",
    "LessHrs": "5:48",
    "TotalHrs": "203:12"
  },
  {
    "s_no": 2,
    "EmployeeId": 2,
    "UserName": "ali",
    "WorkingDays": 25,
    "Present": 0,
    "Late": 21,
    "Absent": 0,
    "Leave": "",
    "Holidays": 0,
    "WeekOff": 4,
    "OTHrs": "14:3",
    "LessHrs": "10:29",
    "TotalHrs": "198:31"
  },
  {
    "s_no": 3,
    "EmployeeId": 3,
    "UserName": "rajesh",
    "WorkingDays": 25,
    "Present": 1,
    "Late": 19,
    "Absent": 1,
    "Leave": "",
    "Holidays": 0,
    "WeekOff": 4,
    "OTHrs": "15:10",
    "LessHrs": "4:21",
    "TotalHrs": "182:39"
  },
  {
    "s_no": 4,
    "EmployeeId": 4,
    "UserName": "Babji",
    "WorkingDays": 25,
    "Present": 16,
    "Late": 5,
    "Absent": 0,
    "Leave": "",
    "Holidays": 0,
    "WeekOff": 4,
    "OTHrs": "18:32",
    "LessHrs": "10",
    "TotalHrs": "197:50"
  },
  {
    "s_no": 5,
    "EmployeeId": 6,
    "UserName": "Chandu",
    "WorkingDays": 25,
    "Present": 5,
    "Late": 9,
    "Absent": 7,
    "Leave": "",
    "Holidays": 0,
    "WeekOff": 4,
    "OTHrs": "1:31",
    "LessHrs": "3:57",
    "TotalHrs": "139:3"
  },
  {
    "s_no": 6,
    "EmployeeId": 8,
    "UserName": "Das",
    "WorkingDays": 25,
    "Present": 14,
    "Late": 4,
    "Absent": 7,
    "Leave": "",
    "Holidays": 0,
    "WeekOff": 4,
    "OTHrs": "15:11",
    "LessHrs": "8:15",
    "TotalHrs": "145:45"
  },
  {
    "s_no": 7,
    "EmployeeId": 12,
    "UserName": "Haleema",
    "WorkingDays": 25,
    "Present": 0,
    "Late": 19,
    "Absent": 2,
    "Leave": "",
    "Holidays": 0,
    "WeekOff": 4,
    "OTHrs": "1:22",
    "LessHrs": "11:32",
    "TotalHrs": "164:28"
  },
  {
    "s_no": 8,
    "EmployeeId": 13,
    "UserName": "Anuradha",
    "WorkingDays": 25,
    "Present": 8,
    "Late": 12,
    "Absent": 1,
    "Leave": "",
    "Holidays": 0,
    "WeekOff": 4,
    "OTHrs": "10:5",
    "LessHrs": "2:29",
    "TotalHrs": "178:39"
  }
]
